import type { BucketStringT } from '../analytics/types/performance';

/**
 * Converts a numeric value into a bucket string for M3 tags.
 * Thresholds define the boundaries between buckets.
 *
 * bucketize(350, [100, 500, 1000]) => "100 - 500"
 * bucketize(50, [100, 500, 1000])  => "<100"
 * bucketize(1000, [100, 500, 1000]) => ">=1000"
 * bucketize(2000, [100, 500, 1000]) => ">=1000"
 */
export function bucketize(value: number, thresholds: number[]): BucketStringT {
  if (thresholds.length === 0) return `<${value}`;
  // After length check, indices are guaranteed to be in-bounds
  const first = thresholds[0]!;
  if (value < first) return `<${first}`;
  for (let i = 0; i < thresholds.length - 1; i++) {
    const lower = thresholds[i]!;
    const upper = thresholds[i + 1]!;
    if (value >= lower && value < upper) {
      return `${lower} - ${upper}`;
    }
  }
  return `>=${thresholds[thresholds.length - 1]!}`;
}